import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'card-update-records';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getCardUpdateRecordsByStudentId({ page, size, student_id }) {
  return get({
    url: `${url}/students/${student_id}`,
    data: { page, size },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function storeAll() {
  return post({
    url: `${url}/all`,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}/`,
    data,
  });
}
